module.exports = __webpack_public_path__ + "media/images/close-934e57a50f7cbb775978d06329f46fe5.png";